module.exports = __webpack_public_path__ + "img/image_7.84771a26.png";